import React, { useState, useContext, useEffect } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css'
import { IonReactRouter } from '@ionic/react-router';
import { Route, Switch } from 'react-router';
//import { IonReactRouter } from '@ionic/react-router';
//import { BrowserRouter } from "react-router-dom";

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context'


import { Tab_Management_Portfolio } from '../components/Tab_Management_Portfolio';
import { Tab_Management_Inventory } from '../components/Tab_Management_Inventory_ProService';
import { Tab_Management_Employee } from '../../../zInternal_Features/merchant/components/Tab_Management_Employee';
import { App_Header } from '../components/App_Header_ProService';
import { App_Footer } from '../components/App_Footer_ProService';
import { Tab_Management_Jobs } from '../../../zInternal_Features/merchant/components/Tab_Management_Jobs';

import { useHistory} from "react-router-dom";


export function ProService_Management (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);

    const [tab_portfolioData, setTab_portfolioData] = useState(true);
    const [tab_inventoryData, setTab_inventoryData] = useState(false);
    const [tab_employeeData, setTab_employeeData] = useState(false);
    const [tab_jobsData, setTab_jobsData] = useState(false);

    const [tab_portfolioView, setTab_portfolioView] = useState('outline');
    const [tab_inventoryView, setTab_inventoryView] = useState('clear');
    const [tab_employeeView, setTab_employeeView] = useState('clear');
    const [tab_jobsView, setTab_jobsView] = useState('clear');

    let history = useHistory();

    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);
        history.push(event);
        props.closeModal();
        //window.location.pathname = event;

    }

    function tab_portfolioHandler()
    {
        setTab_portfolioData(true);
        setTab_inventoryData(false);
        setTab_employeeData(false);
        setTab_jobsData(false);

        setTab_portfolioView('outline');
        setTab_inventoryView('clear');
        setTab_employeeView('clear');
        setTab_jobsView('clear');

    }


    function tab_inventoryHandler()
    {
        setTab_portfolioData(false);
        setTab_inventoryData(true);
        setTab_employeeData(false);
        setTab_jobsData(false);

        setTab_portfolioView('clear');
        setTab_inventoryView('outline');
        setTab_employeeView('clear');
        setTab_jobsView('clear');

    }
    function tab_employeeHandler()
    {
        setTab_portfolioData(false);
        setTab_inventoryData(false);
        setTab_employeeData(true);
        setTab_jobsData(false);

        setTab_portfolioView('clear');
        setTab_inventoryView('clear');
        setTab_employeeView('outline');
        setTab_jobsView('clear');

    }
    function tab_jobsHandler()
    {
        setTab_portfolioData(false);
        setTab_inventoryData(false);
        setTab_employeeData(false);
        setTab_jobsData(true);

        setTab_portfolioView('clear');
        setTab_inventoryView('clear');
        setTab_employeeView('clear');
        setTab_jobsView('outline');

    }

    useEffect(() => {
        // Programmatically navigate to the Inventory tab on component mount
        tab_portfolioHandler();
    }, []);


    return (
            <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal isOpen={props.openModal}>

            <IonHeader> 
                <IonGrid>
                    <IonRow  >
                        <IonCol size='3' >
                            <IonButton  className= 'small-button-tabs' fill={tab_portfolioView} onClick={() =>  tab_portfolioHandler()}>Portfolio</IonButton>
                        </IonCol>
                        <IonCol size='3' >
                            <IonButton  className= 'small-button-tabs' fill={tab_inventoryView} onClick={() =>  tab_inventoryHandler()}>Inventory</IonButton>
                        </IonCol>
                        {(authenticatedMerchent_context.accessRights[0] == 'admin' && (JSON.parse(authenticatedMerchent_context.feature).employeeHR == 'ACTIVE' || JSON.parse(authenticatedMerchent_context.feature).employeeHR == 'INACTIVE')) && <IonCol size='3' >
                            <IonButton  className= 'small-button-tabs' fill={tab_employeeView} onClick={() =>  tab_employeeHandler()}>Employee</IonButton>
                        </IonCol>}
                        {((authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager') && (JSON.parse(authenticatedMerchent_context.feature).jobs == 'ACTIVE' || JSON.parse(authenticatedMerchent_context.feature).employeeHR == 'INACTIVE')) && <IonCol size='3' >
                            <IonButton  className= 'small-button-tabs' fill={tab_jobsView} onClick={() =>  tab_jobsHandler()}>Jobs</IonButton>
                        </IonCol>}
                    </IonRow>
                </IonGrid>
            </IonHeader >


                {tab_portfolioData == true &&  <Tab_Management_Portfolio  accountID={ acctID } employeeID={ employeeID } schemaName={ schema } />}
                {tab_inventoryData == true &&  <Tab_Management_Inventory  accountID={ acctID } employeeID={ employeeID } schemaName={ schema } />}
                {tab_employeeData == true && <Tab_Management_Employee  />}  
                {tab_jobsData == true && <Tab_Management_Jobs  />}    

            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow >
                        <IonCol size='12'>
                            <IonButton onClick={() =>  handleRoute('/proService_merchantMainPageApp')}>Close</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
            </IonModal>
            ): null }

        </React.Fragment>
    );
};


export default ProService_Management;